import React, { memo, useState } from 'react';
import s from './DataBarsWrapper.scss';
import InfoMsg from '../InfoMsg/InfoMsg';

const DataBarsWrapper = ({
  children,
  totalSeats,
  majority,
  exitPoll,
  noMinHeight,
  countOfLeadPlusWins = false,
  infoMsg = '',
}) => {
  const [showMore, setShowMore] = useState(false);
  const handleShowMore = () => {
    setShowMore(true);
  };

  return (
    <div className={s.dataBarsContainer}>
      <div
        className={`${s.dataBarWrapper} ${
          noMinHeight || showMore ? s.noMinHeight : ''
        }`}
      >
        <div className={s.dbwInner}>
          <div className={s.dbTopHead}>
            <div className={s.totalSeats}>
              Seats: {totalSeats}
              {infoMsg && <InfoMsg msg={infoMsg} />}
            </div>
            {exitPoll && <span>Expected</span>}
            {countOfLeadPlusWins &&
              (countOfLeadPlusWins.winCount === totalSeats ? (
                <span>Results</span>
              ) : (
                <span>L + W</span>
              ))}
          </div>
          {majority && (
            <div className={s.majorityMark}>Majority: {majority}</div>
          )}
          {children}
        </div>
      </div>
      {!noMinHeight &&
        !showMore &&
        children &&
        React.Children.count(children) > 4 && (
          <div className={s.showMoreBtn} onClick={handleShowMore} />
        )}
    </div>
  );
};

export default memo(DataBarsWrapper);
